<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Manage Survey
    </div>
    <div class="card-header nocollapse bg-info col-md-12 msg-container" *ngIf="successOrFailureMessage!==''">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>
    <div class="page-attributes p-1">
      <button type="button" class="btn btn-sm btn-primary" (click)="redirectMenu(-1)" [routerLink]="['../survey-configuration',-1]"><i class="fa fa-user-plus"></i> Add New</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="redirectOwnwerMenu(0)" [routerLink]="['../surveyowner',0]" *ngIf="this.workspaceId=='2'"><i class="fa fa-cube"></i> Manage Survey Owner</button>
    </div>


    <ag-grid-angular style="height: 400px;"
                     class="ag-theme-balham"
                     [rowData]="allSurveyList"
                     [columnDefs]="columnDefs"
                     (gridReady)="onGridReady($event)"
                     (rowSelected)="onRowChecked($event)"
                     rowSelection="multiple"
                     [pagination]="true"
                     [paginationPageSize]="10">
    </ag-grid-angular>
    <div *ngIf="showDeleteModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
      <!--<div class="modal fade" id="deleteSurveyModelConfirmation" tabindex="-1" role="dialog" aria-labelledby="deleteSurveyModel" aria-hidden="true">-->
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Delete question confirmation</h5>
            <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-control-label">
              Are you sure you want to delete this survey ?

            </div>
            <br />
            <div class="red form-control-label">
              <b> NOTE:</b><br />
              If this survey is already mapped to service lines,then survey and service line mapping will be deleted.<br />
              If the survey is already started, then available user responses will be deleted.<br />
            </div>
            <br />
            <div class="modal-footer">
              <button type="button" data-dismiss="modal" (click)="deleteSurvey()" class="btn btn-sm btn-primary"><i class="fa fa-trash"></i> Delete</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="closeModal()" data-dismiss="modal"><i class="fa fa-remove"></i> Close</button>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showCopyModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
      <!--<div class="modal fade" id="copySurveyModel" tabindex="-1" role="dialog" aria-labelledby="copySurveyModel" aria-hidden="true">-->
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Copy Survey</h5>
            <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form [formGroup]="copySurveyForm" #f="ngForm">
            <div class="modal-body  p-0">
              <div class="card-header nocollapse bg-info col-md-12 msg-container p-2">
                <b>Source survey Name : </b>{{currentSelectedSurveyName}}
              </div>

              <div class="form-group p-1">
                <table>
                  <tr>
                    <td>
                      <label for="surveyName" class="form-control-label">New Survey Name</label>
                    </td>
                    <td> <input type="text" name="surveyName" id="surveyName" formControlName="surveyName" class="form-control-sm" /></td>
                  </tr>

                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-primary" (click)="closeModal()" data-dismiss="modal"><i class="fa fa-remove"></i> Close</button>
              <button type="button" class="btn btn-sm btn-primary" [disabled]="!copySurveyForm.valid" data-dismiss="modal" (click)="CopySurvey()"><i class="fa fa-copy"></i> Copy</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
